import { FontFamily } from '../hooks/useFontManager';

// 폰트 파일들을 import하여 번들에 포함
import PretendardJPThin from '../assets/fonts/PretendardJP-Thin.ttf';
import PretendardJPExtraLight from '../assets/fonts/PretendardJP-ExtraLight.ttf';
import PretendardJPLight from '../assets/fonts/PretendardJP-Light.ttf';
import PretendardJPRegular from '../assets/fonts/PretendardJP-Regular.ttf';
import PretendardJPMedium from '../assets/fonts/PretendardJP-Medium.ttf';
import PretendardJPSemiBold from '../assets/fonts/PretendardJP-SemiBold.ttf';
import PretendardJPBold from '../assets/fonts/PretendardJP-Bold.ttf';
import PretendardJPExtraBold from '../assets/fonts/PretendardJP-ExtraBold.ttf';
import PretendardJPBlack from '../assets/fonts/PretendardJP-Black.ttf';
import MonsieurLaDoulaise from '../assets/fonts/MonsieurLaDoulaise-Regular.ttf';
import Niconne from '../assets/fonts/Niconne-Regular.ttf';

// Dela Gothic One
import DelaGothicOneRegular from '../assets/fonts/Dela_Gothic_One/DelaGothicOne-Regular.ttf';

// DM Serif Text
import DMSerifTextRegular from '../assets/fonts/DM_Serif_Text/DMSerifText-Regular.ttf';
import DMSerifTextItalic from '../assets/fonts/DM_Serif_Text/DMSerifText-Italic.ttf';

// Hachi Maru Pop
import HachiMaruPopRegular from '../assets/fonts/Hachi_Maru_Pop/HachiMaruPop-Regular.ttf';

// M PLUS 1p
import MPLUS1pThin from '../assets/fonts/M_PLUS_1p/MPLUS1p-Thin.ttf';
import MPLUS1pLight from '../assets/fonts/M_PLUS_1p/MPLUS1p-Light.ttf';
import MPLUS1pRegular from '../assets/fonts/M_PLUS_1p/MPLUS1p-Regular.ttf';
import MPLUS1pMedium from '../assets/fonts/M_PLUS_1p/MPLUS1p-Medium.ttf';
import MPLUS1pBold from '../assets/fonts/M_PLUS_1p/MPLUS1p-Bold.ttf';
import MPLUS1pExtraBold from '../assets/fonts/M_PLUS_1p/MPLUS1p-ExtraBold.ttf';
import MPLUS1pBlack from '../assets/fonts/M_PLUS_1p/MPLUS1p-Black.ttf';

// M PLUS Rounded 1c
import MPLUSRounded1cThin from '../assets/fonts/M_PLUS_Rounded_1c/MPLUSRounded1c-Thin.ttf';
import MPLUSRounded1cLight from '../assets/fonts/M_PLUS_Rounded_1c/MPLUSRounded1c-Light.ttf';
import MPLUSRounded1cRegular from '../assets/fonts/M_PLUS_Rounded_1c/MPLUSRounded1c-Regular.ttf';
import MPLUSRounded1cMedium from '../assets/fonts/M_PLUS_Rounded_1c/MPLUSRounded1c-Medium.ttf';
import MPLUSRounded1cBold from '../assets/fonts/M_PLUS_Rounded_1c/MPLUSRounded1c-Bold.ttf';
import MPLUSRounded1cExtraBold from '../assets/fonts/M_PLUS_Rounded_1c/MPLUSRounded1c-ExtraBold.ttf';
import MPLUSRounded1cBlack from '../assets/fonts/M_PLUS_Rounded_1c/MPLUSRounded1c-Black.ttf';

// Mochiy Pop P One
import MochiyPopPOneRegular from '../assets/fonts/Mochiy_Pop_P_One/MochiyPopPOne-Regular.ttf';

// Zen Old Mincho
import ZenOldMinchoRegular from '../assets/fonts/Zen_Old_Mincho/ZenOldMincho-Regular.ttf';
import ZenOldMinchoMedium from '../assets/fonts/Zen_Old_Mincho/ZenOldMincho-Medium.ttf';
import ZenOldMinchoSemiBold from '../assets/fonts/Zen_Old_Mincho/ZenOldMincho-SemiBold.ttf';
import ZenOldMinchoBold from '../assets/fonts/Zen_Old_Mincho/ZenOldMincho-Bold.ttf';
import ZenOldMinchoBlack from '../assets/fonts/Zen_Old_Mincho/ZenOldMincho-Black.ttf';


// 폰트 파일 경로 매핑
const fontFileMap: Record<string, string> = {
  'PretendardJP-Thin.ttf': PretendardJPThin,
  'PretendardJP-ExtraLight.ttf': PretendardJPExtraLight,
  'PretendardJP-Light.ttf': PretendardJPLight,
  'PretendardJP-Regular.ttf': PretendardJPRegular,
  'PretendardJP-Medium.ttf': PretendardJPMedium,
  'PretendardJP-SemiBold.ttf': PretendardJPSemiBold,
  'PretendardJP-Bold.ttf': PretendardJPBold,
  'PretendardJP-ExtraBold.ttf': PretendardJPExtraBold,
  'PretendardJP-Black.ttf': PretendardJPBlack,
  'MonsieurLaDoulaise-Regular.ttf': MonsieurLaDoulaise,
  'Niconne-Regular.ttf': Niconne,
  'DelaGothicOne-Regular.ttf': DelaGothicOneRegular,
  'DMSerifText-Regular.ttf': DMSerifTextRegular,
  'DMSerifText-Italic.ttf': DMSerifTextItalic,
  'HachiMaruPop-Regular.ttf': HachiMaruPopRegular,
  'MPLUS1p-Thin.ttf': MPLUS1pThin,
  'MPLUS1p-Light.ttf': MPLUS1pLight,
  'MPLUS1p-Regular.ttf': MPLUS1pRegular,
  'MPLUS1p-Medium.ttf': MPLUS1pMedium,
  'MPLUS1p-Bold.ttf': MPLUS1pBold,
  'MPLUS1p-ExtraBold.ttf': MPLUS1pExtraBold,
  'MPLUS1p-Black.ttf': MPLUS1pBlack,
  'MPLUSRounded1c-Thin.ttf': MPLUSRounded1cThin,
  'MPLUSRounded1c-Light.ttf': MPLUSRounded1cLight,
  'MPLUSRounded1c-Regular.ttf': MPLUSRounded1cRegular,
  'MPLUSRounded1c-Medium.ttf': MPLUSRounded1cMedium,
  'MPLUSRounded1c-Bold.ttf': MPLUSRounded1cBold,
  'MPLUSRounded1c-ExtraBold.ttf': MPLUSRounded1cExtraBold,
  'MPLUSRounded1c-Black.ttf': MPLUSRounded1cBlack,
  'MochiyPopPOne-Regular.ttf': MochiyPopPOneRegular,
  'ZenOldMincho-Regular.ttf': ZenOldMinchoRegular,
  'ZenOldMincho-Medium.ttf': ZenOldMinchoMedium,
  'ZenOldMincho-SemiBold.ttf': ZenOldMinchoSemiBold,
  'ZenOldMincho-Bold.ttf': ZenOldMinchoBold,
  'ZenOldMincho-Black.ttf': ZenOldMinchoBlack
};

// 폰트 데이터
export const fontData: FontFamily[] = [
  {
    family: 'PretendardJP',
    name: 'PretendardJP',
    language: '일본어',
    weights: [
      {
        file: 'PretendardJP-Thin.ttf',
        name: 'Thin',
        weight: '100',
        value: '100'
      },
      {
        file: 'PretendardJP-ExtraLight.ttf',
        name: 'ExtraLight',
        weight: '200',
        value: '200'
      },
      {
        file: 'PretendardJP-Light.ttf',
        name: 'Light',
        weight: '300',
        value: '300'
      },
      {
        file: 'PretendardJP-Regular.ttf',
        name: 'Regular',
        weight: '400',
        value: '400'
      },
      {
        file: 'PretendardJP-Medium.ttf',
        name: 'Medium',
        weight: '500',
        value: '500'
      },
      {
        file: 'PretendardJP-SemiBold.ttf',
        name: 'SemiBold',
        weight: '600',
        value: '600'
      },
      {
        file: 'PretendardJP-Bold.ttf',
        name: 'Bold',
        weight: '700',
        value: '700'
      },
      {
        file: 'PretendardJP-ExtraBold.ttf',
        name: 'ExtraBold',
        weight: '800',
        value: '800'
      },
      {
        file: 'PretendardJP-Black.ttf',
        name: 'Black',
        weight: '900',
        value: '900'
      }
    ]
  },
  {
    family: 'MonsieurLaDoulaise',
    name: 'MonsieurLaDoulaise',
    language: '영어',
    weights: [
      {
        file: 'MonsieurLaDoulaise-Regular.ttf',
        name: 'Regular',
        weight: '400',
        value: '400'
      },
    ]
  },
  {
    family: 'Niconne',
    name: 'Niconne',
    language: '영어',
    weights: [
      {
        file: 'Niconne-Regular.ttf',
        name: 'Regular',
        weight: '400',
        value: '400'
      },
    ]
  },
  {
    family: 'Dela Gothic One',
    name: 'Dela Gothic One',
    language: '일본어',
    weights: [
      {
        file: 'DelaGothicOne-Regular.ttf',
        name: 'Regular',
        weight: '400',
        value: '400'
      }
    ]
  },
  {
    family: 'DM Serif Text',
    name: 'DM Serif Text',
    language: '영어',
    weights: [
      {
        file: 'DMSerifText-Regular.ttf',
        name: 'Regular',
        weight: '400',
        value: '400'
      },
      {
        file: 'DMSerifText-Italic.ttf',
        name: 'Italic',
        weight: '500',
        value: '500'
      }
    ]
  },
  {
    family: 'Hachi Maru Pop',
    name: 'Hachi Maru Pop',
    language: '일본어',
    weights: [
      {
        file: 'HachiMaruPop-Regular.ttf',
        name: 'Regular',
        weight: '400',
        value: '400'
      }
    ]
  },
  {
    family: 'M PLUS 1p',
    name: 'M PLUS 1p',
    language: '일본어',
    weights: [
      {
        file: 'MPLUS1p-Thin.ttf',
        name: 'Thin',
        weight: '100',
        value: '100'
      },
      {
        file: 'MPLUS1p-Light.ttf',
        name: 'Light',
        weight: '300',
        value: '300'
      },
      {
        file: 'MPLUS1p-Regular.ttf',
        name: 'Regular',
        weight: '400',
        value: '400'
      },
      {
        file: 'MPLUS1p-Medium.ttf',
        name: 'Medium',
        weight: '500',
        value: '500'
      },
      {
        file: 'MPLUS1p-Bold.ttf',
        name: 'Bold',
        weight: '700',
        value: '700'
      },
      {
        file: 'MPLUS1p-ExtraBold.ttf',
        name: 'ExtraBold',
        weight: '800',
        value: '800'
      },
      {
        file: 'MPLUS1p-Black.ttf',
        name: 'Black',
        weight: '900',
        value: '900'
      }
    ]
  },
  {
    family: 'M PLUS Rounded 1c',
    name: 'M PLUS Rounded 1c',
    language: '일본어',
    weights: [
      {
        file: 'MPLUSRounded1c-Thin.ttf',
        name: 'Thin',
        weight: '100',
        value: '100'
      },
      {
        file: 'MPLUSRounded1c-Light.ttf',
        name: 'Light',
        weight: '300',
        value: '300'
      },
      {
        file: 'MPLUSRounded1c-Regular.ttf',
        name: 'Regular',
        weight: '400',
        value: '400'
      },
      {
        file: 'MPLUSRounded1c-Medium.ttf',
        name: 'Medium',
        weight: '500',
        value: '500'
      },
      {
        file: 'MPLUSRounded1c-Bold.ttf',
        name: 'Bold',
        weight: '700',
        value: '700'
      },
      {
        file: 'MPLUSRounded1c-ExtraBold.ttf',
        name: 'ExtraBold',
        weight: '800',
        value: '800'
      },
      {
        file: 'MPLUSRounded1c-Black.ttf',
        name: 'Black',
        weight: '900',
        value: '900'
      }
    ]
  },
  {
    family: 'Mochiy Pop P One',
    name: 'Mochiy Pop P One',
    language: '일본어',
    weights: [
      {
        file: 'MochiyPopPOne-Regular.ttf',
        name: 'Regular',
        weight: '400',
        value: '400'
      }
    ]
  },
  {
    family: 'Zen Old Mincho',
    name: 'Zen Old Mincho',
    language: '일본어',
    weights: [
      {
        file: 'ZenOldMincho-Regular.ttf',
        name: 'Regular',
        weight: '400',
        value: '400'
      },
      {
        file: 'ZenOldMincho-Medium.ttf',
        name: 'Medium',
        weight: '500',
        value: '500'
      },
      {
        file: 'ZenOldMincho-SemiBold.ttf',
        name: 'SemiBold',
        weight: '600',
        value: '600'
      },
      {
        file: 'ZenOldMincho-Bold.ttf',
        name: 'Bold',
        weight: '700',
        value: '700'
      },
      {
        file: 'ZenOldMincho-Black.ttf',
        name: 'Black',
        weight: '900',
        value: '900'
      }
    ]
  }
];

// 폰트 파일 경로를 가져오는 헬퍼 함수
export function getFontPath(fileName: string): string {
  return fontFileMap[fileName] || '';
}

// Webpack tree-shaking 방지: 모든 폰트 파일을 명시적으로 export하여 번들에 포함
export const _fontImports = {
  PretendardJPThin,
  PretendardJPExtraLight,
  PretendardJPLight,
  PretendardJPRegular,
  PretendardJPMedium,
  PretendardJPSemiBold,
  PretendardJPBold,
  PretendardJPExtraBold,
  PretendardJPBlack,
  MonsieurLaDoulaise,
  Niconne,
  DelaGothicOneRegular,
  DMSerifTextRegular,
  DMSerifTextItalic,
  HachiMaruPopRegular,
  MPLUS1pThin,
  MPLUS1pLight,
  MPLUS1pRegular,
  MPLUS1pMedium,
  MPLUS1pBold,
  MPLUS1pExtraBold,
  MPLUS1pBlack,
  MPLUSRounded1cThin,
  MPLUSRounded1cLight,
  MPLUSRounded1cRegular,
  MPLUSRounded1cMedium,
  MPLUSRounded1cBold,
  MPLUSRounded1cExtraBold,
  MPLUSRounded1cBlack,
  MochiyPopPOneRegular,
  ZenOldMinchoRegular,
  ZenOldMinchoMedium,
  ZenOldMinchoSemiBold,
  ZenOldMinchoBold,
  ZenOldMinchoBlack
};